import React from 'react';
import { partners } from '../data/site';
import { Reveal } from './Reveal';
export function Partners() {
  return <section className="border-t border-line bg-chalk py-14" data-id="element-87" data-mp="23ktzlg393zcm">
      <div className="mx-auto max-w-shell px-6 lg:px-10" data-id="element-88" data-mp="1pjztx57l8chn">
        <Reveal data-id="element-89" data-mp="1plkouvxtdxg1">
          <div className="flex flex-col gap-8 lg:flex-row lg:items-center lg:gap-16" data-id="element-90" data-mp="1pm2nfz7y8nr4">
            <p className="shrink-0 text-[11px] uppercase tracking-label text-graphite" data-id="element-91" data-mp="1ujcns9wvmjtq">
              Mes partenaires de confiance
            </p>
            <ul className="flex flex-wrap items-center gap-x-10 gap-y-3" data-id="element-92" data-mp="2mas6vtz85of7">
              {partners.map(partner => <li key={partner} className="font-display text-xl text-ink/60" data-id="element-93" data-mp="28hsw25ae0idz">
                  {partner}
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>
    </section>;
}